import { useEffect, useState } from 'react';
import { Bell, Check } from 'lucide-react';
import { api } from '@/lib/api';

export default function Reminders() {
  const [items, setItems] = useState([]);
  const load = () => api('/reminders').then(setItems);
  useEffect(() => { load(); }, []);

  const complete = async (id) => {
    await api(`/reminders/${id}`, { method: 'PATCH', body: JSON.stringify({ status: 'done' }) });
    load();
  };

  const open = items.filter((r) => r.status === 'open');
  const done = items.filter((r) => r.status === 'done');

  return (
    <>
      <div className="page-head">
        <div>
          <span className="eyebrow">CASE MANAGEMENT</span>
          <h1>Follow-ups</h1>
          <p className="muted">Keep investigations moving and commitments visible.</p>
        </div>
      </div>
      <section className="panel">
        <div className="panel-title"><div><span className="eyebrow">OPEN</span><h2>Upcoming follow-ups</h2></div></div>
        {open.length === 0 && <p className="muted" style={{ marginTop: 18 }}>Nothing due right now.</p>}
        {open.map((r) => (
          <div className="focus-item" data-testid={`reminder-${r.id}`} key={r.id}>
            <div className="focus-icon amber"><Bell size={14} /></div>
            <div>
              <strong>{r.description}</strong>
              <p>Case {r.case_id} · due {r.due_date}</p>
            </div>
            <button data-testid={`reminder-done-${r.id}`} className="secondary-btn" onClick={() => complete(r.id)}>
              <Check size={14} /> Mark done
            </button>
          </div>
        ))}
      </section>
      {done.length > 0 && (
        <section className="panel" style={{ marginTop: 14 }}>
          <div className="panel-title"><div><span className="eyebrow">COMPLETED</span><h2>Recently closed</h2></div></div>
          {done.map((r) => (
            <div className="focus-item" key={r.id}>
              <div className="focus-icon blue"><Check size={14} /></div>
              <div><strong>{r.description}</strong><p>Case {r.case_id} · was due {r.due_date}</p></div>
              <span>done</span>
            </div>
          ))}
        </section>
      )}
    </>
  );
}
